var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"properties-title"},[_vm._v("Columns:")]),_c('PpCombobox',{attrs:{"items":_vm.items,"appended-icon":_vm.appendedIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }